/** Research editions live under /pulse (hot takes from bank research). */
export function isResearchDeskPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return pathname === "/pulse" || pathname.startsWith("/pulse/");
}

export function formatDeskShortDate(isoDate: string): string {
  const date = new Date(`${isoDate}T00:00:00`);
  if (Number.isNaN(date.getTime())) return isoDate;
  return date
    .toLocaleDateString("en-US", { month: "short", day: "numeric" })
    .toUpperCase();
}
